<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                <strong>Statutory Inspection Report -</strong>
                Serial No: {{ statInsp.serialNo }}&nbsp;
                <Badge v-if="!statInsp.isActive" type="warning">Archived</Badge>
              </h4>
            </div>
            <edit-button
              v-if="statInsp.isActive"
              @edit-click="EditStatInsp"
            ></edit-button>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Report Date:</strong>
                  <br />
                  {{ statInsp.reportDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p v-bind:class="{ 'text-warning': statInsp.isExpired }">
                  <strong>Next Report Due:</strong>
                  <br />
                  {{ statInsp.nextReportDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p v-if="statInsp.reminderDate != null">
                  <strong>Reminder Date:</strong>
                  <br />
                  {{ statInsp.reminderDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p v-else>
                  <strong>Reminder Date:</strong>
                  <br />OFF
                </p>
                <p v-bind:class="{ 'text-danger': statInsp.isOverdue }">
                  <strong>Overdue Date:</strong>
                  <br />
                  {{ statInsp.overdueDate | moment("dddd, MMMM Do YYYY") }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Created Date:</strong>
                  <br />
                  {{ statInsp.createdDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p>
                  <strong>Last Activity:</strong>
                  <br />
                  {{ statInsp.lastUpdatedDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p>
                  <strong>Last Updated by:</strong>
                  <br />
                  {{ statInsp.lastUpdatedBy }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Contractor:</strong>
                  <br />
                  {{ statInsp.contractorName }}
                </p>
                <p>
                  <strong>Contractor Region:</strong>
                  <br />
                  {{ statInsp.contractorRegionName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Client:</strong>
                  <br />
                  {{ statInsp.clientName }}
                </p>
                <p>
                  <strong>Site:</strong>
                  <br />
                  {{ statInsp.siteName }}
                </p>
                <p>
                  <strong>Building:</strong>
                  <br />
                  {{ statInsp.buildingName }}
                </p>
                <p>
                  <br />
                  <md-button
                    v-if="this.$auth.isInGlobalRole() && statInsp.isActive"
                    @click="createNextStatInsp()"
                    >Create Next Stat. Insp.</md-button
                  >
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card v-show="statInsp.isPartial" class="md-accent" md-with-hover>
          <md-ripple>
            <md-card-content>
              <strong>PARTIAL/NON INSPECTION:</strong>
              {{ statInsp.partialNote }}
            </md-card-content>
          </md-ripple>
        </md-card>
        <statInspItemList></statInspItemList>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card v-if="statInsp.releatedStatutoryInspections.length > 1">
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ icon }}</md-icon>
            </div>
            <h4 class="title">Switch Stat. Insp.</h4>
          </md-card-header>
          <md-card-content>
            <md-field>
              <md-select
                v-model="selectedRelatedStatInsp"
                name="relatedStatInsps"
                id="relatedStatInsps"
                @md-selected="navigateToStatInsp"
              >
                <md-option
                  v-for="rel in statInsp.releatedStatutoryInspections"
                  :key="rel.id"
                  :value="rel.id"
                >
                  {{ rel.reportDate | moment("dddd, MMMM Do YYYY") }}
                </md-option>
              </md-select>
            </md-field>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Badge } from "@/components";
import { mapGetters } from "vuex";
import moment from "moment";
import StatInspItemList from "../stat-insp-item/StatInspItemList";

export default {
  data() {
    return {
      selectedRelatedStatInsp: this.$route.params.statInspId
    };
  },
  components: {
    Badge,
    StatInspItemList
  },
  computed: {
    ...mapGetters({
      icon: "stat-insp/icon",
      statInsp: "stat-insp/statInsp"
    })
  },
  async created() {
    await this.$store.dispatch(
      "stat-insp/getStatInsp",
      this.$route.params.statInspId
    );
  },
  methods: {
    async navigateToStatInsp() {
      this.$router.push({
        name: "Statutory Inspection",
        params: { statInspId: this.selectedRelatedStatInsp }
      });
      await this.$store.dispatch(
        "stat-insp/getStatInsp",
        this.$route.params.statInspId
      );
    },
    EditStatInsp() {
      this.$router.push({
        name: "Edit Statutory Inspection",
        params: { statInspId: this.$route.params.statInspId }
      });
    },
    createNextStatInsp() {
      if (moment().isBefore(this.statInsp.nextReportDate)) {
        if (
          !window.confirm(
            "Are you sure you wish to continue? A new report is not due until " +
              moment(this.statInsp.nextReportDate).format("DD-MM-YYYY")
          )
        ) {
          return;
        }
      }
      this.$router.push({
        path: `create-next-report/${this.$route.params.statInspId}`
      });
    }
  }
};
</script>

<style></style>
